document.addEventListener("DOMContentLoaded", function () {
    var bannerSlider = document.querySelector(".banner-video-slider");

    if (bannerSlider) {
        var slides = bannerSlider.children;
        var isMobile = window.innerWidth <= 768;

        if (slides.length > 1) {
            $(bannerSlider).css("visibility", "hidden");

            $(bannerSlider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: !isMobile,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                prevArrow: '<button tabindex="-1" type="button" aria-label="previous" class="slick-arrow slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
                nextArrow: '<button tabindex="0" type="button" aria-label="next" class="slick-arrow slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
                
            });

            setTimeout(function () {
                $(bannerSlider).css({ visibility: "visible", opacity: "1" });
            }, 100);
        } else {
            $(bannerSlider).css({ visibility: "visible", opacity: "1" });
        }
    }
});
